import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import { PvButtonOutline } from 'styles/CustomComponents';

class ConfirmButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickCount: 0
    };

    const confirm = () => {
      if (this.state.clickCount === 1)
        this.props.onClick();
      else
        this.setState({clickCount: this.state.clickCount + 1});
    };

    this.confirm = confirm.bind(this);
  }

  render() {
    const {children} = this.props;

    const {clickCount} = this.state;

    return (
      <PvButtonOutline
        {...this.props}
        className={clickCount === 1 && 'confirm-btn-action'}
        onClick={() => this.confirm()}>
        {clickCount === 0 && children}
        {clickCount >= 1 && <Translate value='action.click_to_confirm_remove' />}
      </PvButtonOutline>
    );
  }
}

ConfirmButton.props = {
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default ConfirmButton;


// WEBPACK FOOTER //
// ./src/components/ConfirmButton.jsx